module.exports = __webpack_public_path__ + "static/fonts/icons.c08753f.ttf";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/src/fonts/icons.ttf
// module id = PqNn
// module chunks = 1